module.exports = __webpack_public_path__ + "static/media/arrow_top.8e4de27a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/404/static/img/arrow_top.svg
// module id = 2074
// module chunks = 118